import { browserSupportsWebSockets } from './browserSupportsWebSockets';
import { webSocketsDeactivated } from './webSocketsDeactivated';

export function webSocketsAvailable() {
  return browserSupportsWebSockets() && !webSocketsDeactivated();
}
